import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLifenLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24.1813 13.6002V7.70782H12.0846C12.0846 14.3752 6.67432 19.7799 0 19.7799V31.852C6.05559 31.852 11.5903 29.6247 15.8308 25.9487V31.852H27.9154C27.9154 25.1846 33.3257 19.7799 40 19.7799V7.70782C33.9492 7.70782 28.4205 9.93029 24.1813 13.6002Z",
		fill: "currentColor"
	})
});
export default SvgLifenLogo;
